var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showPDT
        ? _c(
            "v-container",
            [
              _c(
                "v-row",
                { staticClass: "noImprimir" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-app-bar",
                        { staticClass: "appbarPrint", attrs: { absolute: "" } },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(
                              "Permiso de Acceso (Ticket N° " +
                                _vm._s(_vm.PDTDetail.id) +
                                ")"
                            )
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-5",
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.print()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v("mdi-printer")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "appbarSpace" },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "centerItem p25" }, [
                            _c("img", {
                              staticClass: "logoPDT",
                              attrs: {
                                src: require("../../assets/tecnologicagente.jpg"),
                                alt: "Logo Daycohost"
                              }
                            })
                          ]),
                          _c("td", { staticClass: "centerItem p50" }, [
                            _c("b", [_vm._v("GESTIÓN DE ACCESOS Y CAMBIOS")])
                          ]),
                          _c("td", { staticClass: "p25" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [_vm._v("Código")]),
                              _vm._v(": FOR-CAM-001")
                            ]),
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [_vm._v("Rev.")]),
                              _vm._v(": 02")
                            ]),
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [_vm._v("Fecha Rev.")]),
                              _vm._v(": noviembre 2017")
                            ])
                          ])
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "centerItem p100",
                              attrs: { colspan: "3" }
                            },
                            [
                              _c("h4", { staticClass: "mb-1" }, [
                                _vm._v(
                                  "Solicitud de Accesos y Cambios Daycohost"
                                )
                              ]),
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v(
                                  " Aplica para accesos por motivo de visitas y auditorías visuales, así como ejecución de trabajos en equipamiento colocado de los Usuarios y administrados por Daycohost para Usuarios. "
                                )
                              ]),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  " Complete los datos requeridos y marque una x entre paréntesis la opción correspondiente. "
                                )
                              ])
                            ]
                          )
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "centerItem p100 grayRow",
                              attrs: { colspan: "3" }
                            },
                            [
                              _c("h4", { staticClass: "mb-0" }, [
                                _vm._v("Información del Usuario Solicitante")
                              ])
                            ]
                          )
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "centerItem p100",
                              attrs: { colspan: "3" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "mr-5" },
                                [
                                  _vm._v(" Usuario/Cliente ("),
                                  _c("v-icon", { attrs: { "x-small": "" } }, [
                                    _vm._v("mdi-close")
                                  ]),
                                  _vm._v(")")
                                ],
                                1
                              ),
                              _c("span", [
                                _vm._v(" Proveedor ("),
                                _c("span", { staticClass: "pr-3" }),
                                _vm._v(")")
                              ])
                            ]
                          )
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "p25" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [_vm._v("Nombre de la Empresa")]),
                              _vm._v(" (razón social): ")
                            ])
                          ]),
                          _c(
                            "td",
                            { staticClass: "p75", attrs: { colspan: "2" } },
                            [
                              _c("p", { staticClass: "mb-0 ml-2" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.PDTDetail.customer.name) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "centerItem p30" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [
                                _vm._v("Nombre y Apellido Usuario solicitante")
                              ])
                            ]),
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(
                                " (autorizado en lista de contactos de Daycohost): "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p10" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("C.I.")])
                            ]),
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Solicitante")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p30" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [
                                _vm._v(
                                  "N° Teléf. Contacto Usuario solicitante:"
                                )
                              ])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p30" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Firma de Aprobación")])
                            ]),
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v("(sólo para accesos al Centro de Datos):")
                            ])
                          ])
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "centerItem p30" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getFullName(
                                      _vm.getSpecificContact(
                                        3,
                                        _vm.PDTDetail.accessPermission
                                          .accessContacts
                                      )
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p10" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getCI(
                                      _vm.getSpecificContact(
                                        3,
                                        _vm.PDTDetail.accessPermission
                                          .accessContacts
                                      )
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p30" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getPhone(
                                      _vm.getSpecificContact(
                                        3,
                                        _vm.PDTDetail.accessPermission
                                          .accessContacts
                                      )
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p30" })
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Nombre/Apellido Usuario")])
                            ]),
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Autorizado en sitio:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p25" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFullName(
                                    _vm.getSpecificContact(
                                      1,
                                      _vm.PDTDetail.accessPermission
                                        .accessContacts
                                    )
                                  )
                                ) +
                                " "
                            )
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("N° Teléf. Contacto")])
                            ]),
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Usuario en sitio:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getPhone(
                                    _vm.getSpecificContact(
                                      1,
                                      _vm.PDTDetail.accessPermission
                                        .accessContacts
                                    )
                                  )
                                ) +
                                " "
                            )
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("C.I. Usuario en")])
                            ]),
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("sitio:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getCI(
                                    _vm.getSpecificContact(
                                      1,
                                      _vm.PDTDetail.accessPermission
                                        .accessContacts
                                    )
                                  )
                                ) +
                                " "
                            )
                          ])
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Vehículo")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p12h" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Marca:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p12h" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Modelo:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Placa:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Marca:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Modelo:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c("b", [_vm._v("Placa:")])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c(
                                "span",
                                { staticClass: "mr-5" },
                                [
                                  _vm._v(" Si ("),
                                  _vm.PDTDetail.accessPermission.vehicles
                                    .length > 0
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              ),
                              _c(
                                "span",
                                { staticClass: "mr-5" },
                                [
                                  _vm._v(" No ("),
                                  _vm.PDTDetail.accessPermission.vehicles
                                    .length == 0
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p12h" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm.PDTDetail.accessPermission.vehicles.length > 0
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.PDTDetail.accessPermission
                                          .vehicles[0].brand
                                      )
                                    )
                                  ])
                                : _c("span", [_vm._v("N/A")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p12h" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm.PDTDetail.accessPermission.vehicles.length > 0
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.PDTDetail.accessPermission
                                          .vehicles[0].model
                                      )
                                    )
                                  ])
                                : _c("span", [_vm._v("N/A")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm.PDTDetail.accessPermission.vehicles.length > 0
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.PDTDetail.accessPermission
                                          .vehicles[0].licensePlate
                                      )
                                    )
                                  ])
                                : _c("span", [_vm._v("N/A")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm.PDTDetail.accessPermission.vehicles.length > 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.PDTDetail.accessPermission
                                          .vehicles[1].brand
                                      )
                                    )
                                  ])
                                : _c("span", [_vm._v("N/A")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm.PDTDetail.accessPermission.vehicles.length > 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.PDTDetail.accessPermission
                                          .vehicles[1].model
                                      )
                                    )
                                  ])
                                : _c("span", [_vm._v("N/A")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p15" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _vm.PDTDetail.accessPermission.vehicles.length > 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.PDTDetail.accessPermission
                                          .vehicles[1].licensePlate
                                      )
                                    )
                                  ])
                                : _c("span", [_vm._v("N/A")])
                            ])
                          ])
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "centerItem p100 blueRow",
                              attrs: { colspan: "7" }
                            },
                            [
                              _c("h4", { staticClass: "mb-0" }, [
                                _vm._v(
                                  " Información sobre el motivo de Accesos al Centro de Datos o Cambios, Visitantes y Movimiento de Equipos "
                                )
                              ])
                            ]
                          )
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "centerItem p100",
                              attrs: { colspan: "7" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "mr-3" },
                                [
                                  _vm._v(" Acceso al Centro de Datos ("),
                                  _vm.checkAccessType(1)
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              ),
                              _c(
                                "span",
                                { staticClass: "mr-3" },
                                [
                                  _vm._v(
                                    " Trabajos en Torre de Comunicación ("
                                  ),
                                  _vm.checkAccessType(2)
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              ),
                              _c(
                                "span",
                                { staticClass: "mr-3" },
                                [
                                  _vm._v(
                                    " Cambios Servicios de Clientes administrados por Daycohost ("
                                  ),
                                  _vm.checkAccessType(3)
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "tdbtl p10" }),
                          _c("td", { staticClass: "tdbt p40" }, [
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Visita Guiada ("),
                                _vm.checkAccessMotive(1)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Inspección Visual ("),
                                _vm.checkAccessMotive(2)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  ' Levantamiento de Información "site survey" ('
                                ),
                                _vm.checkAccessMotive(3)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Instalación de servicios ("),
                                _vm.checkAccessMotive(4)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Desinstalación de servicios ("),
                                _vm.checkAccessMotive(5)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Revisión de equipamiento del usuario ("
                                ),
                                _vm.checkAccessMotive(6)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Ejecución de pruebas en equipamiento del usuario ("
                                ),
                                _vm.checkAccessMotive(7)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Mantenimiento en equipamiento del usuario ("
                                ),
                                _vm.checkAccessMotive(8)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Auditoría ("),
                                _vm.checkAccessMotive(16)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Desinstalación de equipamiento del usuario ("
                                ),
                                _vm.checkAccessMotive(19)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            )
                          ]),
                          _c("td", { staticClass: "tdbt p10" }),
                          _c("td", { staticClass: "tdbtr p40" }, [
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Solución de incidentes en equipamiento del usuario ("
                                ),
                                _vm.checkAccessMotive(9)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Cambio de partes y piezas ("),
                                _vm.checkAccessMotive(10)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Sustitución de patch cord en el rack ("
                                ),
                                _vm.checkAccessMotive(11)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Movimiento de equipamiento del usuario ("
                                ),
                                _vm.checkAccessMotive(12)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Instalación de antena en la torre ("),
                                _vm.checkAccessMotive(13)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Desinstalación de antena en la torre ("
                                ),
                                _vm.checkAccessMotive(14)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Mantenimiento de antena en la torre ("
                                ),
                                _vm.checkAccessMotive(15)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(" Acceso tanquillas de fibra óptica ("),
                                _vm.checkAccessMotive(17)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "mb-0 ml-5" },
                              [
                                _vm._v(
                                  " Instalación de equipamiento del usuario ("
                                ),
                                _vm.checkAccessMotive(18)
                                  ? _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v("mdi-close")
                                    ])
                                  : _c("span", { staticClass: "pr-3" }),
                                _vm._v(") ")
                              ],
                              1
                            ),
                            _c("p", { staticClass: "mb-0 ml-5" }, [
                              _vm._v(
                                " Otro (especifique): " +
                                  _vm._s(_vm.getOtherMotive) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "p25" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _vm._v(
                                " Fecha de Inicio: " +
                                  _vm._s(
                                    _vm.getDate(
                                      _vm.PDTDetail.accessPermission.startDate
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "p25" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _vm._v(
                                " Fecha de Fin: " +
                                  _vm._s(
                                    _vm.getDate(
                                      _vm.PDTDetail.accessPermission.endDate
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p25" }, [
                            _c("b", { staticClass: "mb-0" }, [
                              _vm._v(" Cambio de Emergencia: ")
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p25" }, [
                            _c("b", { staticClass: "mb-0" }, [
                              _vm._v(
                                " El Cambio requiere Interrupción de Servicio: "
                              )
                            ])
                          ])
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "p25" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _vm._v(
                                " Hora de Inicio: " +
                                  _vm._s(
                                    _vm.getTimeFromDate(
                                      _vm.PDTDetail.accessPermission.startDate
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "p25" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _vm._v(
                                " Hora de Fin: " +
                                  _vm._s(
                                    _vm.getTimeFromDate(
                                      _vm.PDTDetail.accessPermission.endDate
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p25" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c(
                                "span",
                                { staticClass: "mr-5" },
                                [
                                  _vm._v(" Si ("),
                                  _vm.PDTDetail.accessPermission.emergency
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              ),
                              _c(
                                "span",
                                { staticClass: "mr-5" },
                                [
                                  _vm._v(" No ("),
                                  !_vm.PDTDetail.accessPermission.emergency
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p25" }, [
                            _c("p", { staticClass: "mb-0" }, [
                              _c(
                                "span",
                                { staticClass: "mr-5" },
                                [
                                  _vm._v(" Si ("),
                                  _vm.PDTDetail.accessPermission
                                    .serviceInterruption
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              ),
                              _c(
                                "span",
                                { staticClass: "mr-5" },
                                [
                                  _vm._v(" No ("),
                                  !_vm.PDTDetail.accessPermission
                                    .serviceInterruption
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              )
                            ])
                          ])
                        ]),
                        _c("tr", [
                          _c("td", { staticClass: "p15" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _vm._v(
                                " Comentario sobre el Cambio de Emergencia: "
                              )
                            ])
                          ]),
                          _c(
                            "td",
                            {
                              staticClass: "p100 centerItem",
                              attrs: { colspan: "7" }
                            },
                            [
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.PDTDetail.accessPermission
                                        .emergencyComment
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", { staticClass: "grayRow" }, [
                          _c("td", { staticClass: "p15 tdbtl" }, [
                            _c("span", { staticClass: "ml-1 mr-5" }, [
                              _c("b", [_vm._v("Nombre del sitio a visitar:")])
                            ])
                          ]),
                          _c("td", { staticClass: "centerItem p85 tdbtr" }, [
                            _c("span", { staticClass: "mr-5" }, [
                              _c(
                                "b",
                                [
                                  _vm._v("Torre Dayco Caracas ("),
                                  _vm.checkDataCenter(1)
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              )
                            ]),
                            _c("span", { staticClass: "mr-5" }, [
                              _c(
                                "b",
                                [
                                  _vm._v(
                                    "Centro Tecnológico Daycohost Valencia ("
                                  ),
                                  _vm.checkDataCenter(2)
                                    ? _c(
                                        "v-icon",
                                        { attrs: { "x-small": "" } },
                                        [_vm._v("mdi-close")]
                                      )
                                    : _c("span", { staticClass: "pr-3" }),
                                  _vm._v(")")
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "centerItem p25 pl-2 pr-2 pt-2 pb-2",
                                attrs: { rowspan: "6" }
                              },
                              [
                                _c("b", [
                                  _vm._v(
                                    "Personas involucradas en Accesos o Cambios en las Salas de Datos "
                                  )
                                ]),
                                _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    " (Máximo 5 personas por acceso a la Sala de Datos, incluyendo la persona responsable en sitio) "
                                  )
                                ])
                              ]
                            ),
                            _c("td", { staticClass: "centerItem p25 sameH" }, [
                              _c("b", [_vm._v(" Cédula de Identidad: ")])
                            ]),
                            _c("td", { staticClass: "centerItem p25 sameH" }, [
                              _c("b", [_vm._v(" Nombre y Apellido Usuario: ")])
                            ]),
                            _c("td", { staticClass: "centerItem p25 sameH" }, [
                              _c("b", [_vm._v(" Nombre Empresa: ")])
                            ])
                          ]),
                          _vm._l(_vm.getAuthorizedPeople, function(person) {
                            return _c("tr", { key: person.id }, [
                              _c(
                                "td",
                                { staticClass: "centerItem p25 sameH" },
                                [
                                  _vm._v(
                                    " " + _vm._s(person.identification) + " "
                                  )
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "centerItem p25 sameH" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        person.name + " " + person.lastName
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "centerItem p25 sameH" },
                                [_vm._v(" " + _vm._s(person.company) + " ")]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ]),
                    _c("table", [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "centerItem p100 blueRow",
                                attrs: { colspan: "4" }
                              },
                              [
                                _c("h4", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    " Tareas a ejecutar en las Salas de Datos (especifique): "
                                  )
                                ])
                              ]
                            )
                          ]),
                          _vm._l(_vm.getDataCenterTasks, function(task, index) {
                            return _c("tr", { key: task.id }, [
                              _c("td", { staticClass: "centerItem p5" }, [
                                _vm._v(_vm._s(index + 1) + " .")
                              ]),
                              _c("td", { staticClass: "centerItem p95" }, [
                                _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(" " + _vm._s(task.name) + " ")
                                ])
                              ])
                            ])
                          }),
                          _vm.getDataCenterTasks.length < 1
                            ? _vm._l([1], function(task) {
                                return _c("tr", { key: task }, [
                                  _c("td", { staticClass: "centerItem p5" }, [
                                    _vm._v(_vm._s(task) + ".")
                                  ]),
                                  _c("td", { staticClass: "centerItem p95" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ])
                                ])
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "centerItem p100 blueRow",
                              attrs: { colspan: "4" }
                            },
                            [
                              _c("h4", { staticClass: "mb-0" }, [
                                _vm._v(
                                  " Datos requeridos para ingreso, egreso e instalación de equipos colocados "
                                )
                              ]),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  " (en caso de que se requiera ingresar una cantidad mayor a 4 equipos, es conveniente presentar la lista como un anexo del formato FORM-CAM-001) "
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _c("td", { staticClass: "centerItem p5" }, [
                              _c("b", [_vm._v(" N° ")])
                            ]),
                            _c("td", { staticClass: "centerItem p10" }, [
                              _c("b", [_vm._v(" Ingreso/Egreso ")])
                            ]),
                            _c("td", { staticClass: "centerItem p15" }, [
                              _c("b", [_vm._v(" Nombre del Equipo ")])
                            ]),
                            _c("td", { staticClass: "centerItem p15" }, [
                              _c("b", [_vm._v(" Ubicación en Datacenter ")]),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v("(código Rack o Jaula)")
                              ])
                            ]),
                            _c("td", { staticClass: "centerItem p10" }, [
                              _c("b", [_vm._v(" Modelo: ")])
                            ]),
                            _c("td", { staticClass: "centerItem p10" }, [
                              _c("b", [_vm._v(" Serial: ")])
                            ]),
                            _c("td", { staticClass: "centerItem p20" }, [
                              _c("b", [_vm._v(" Voltaje Nominal ")]),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v('(valor alimentación del equipo "V")')
                              ])
                            ]),
                            _c("td", { staticClass: "centerItem p25" }, [
                              _c("b", [_vm._v(" Consumo Nominal ")]),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  '(valor potencia que demanda el equipo "KW")'
                                )
                              ])
                            ])
                          ]),
                          _vm._l(
                            _vm.PDTDetail.accessPermission
                              .accessPermissionEquipments,
                            function(hardware, index) {
                              return _c("tr", { key: hardware.id }, [
                                _c("td", { staticClass: "centerItem p5" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(index + 1) + ".")
                                  ])
                                ]),
                                _c("td", { staticClass: "centerItem p10" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getMovementType(
                                            hardware.movementType.id
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ]),
                                _c("td", { staticClass: "centerItem p15" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      _vm._s(hardware.accessEquipment.name)
                                    )
                                  ])
                                ]),
                                _c("td", { staticClass: "centerItem p15" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      _vm._s(hardware.accessEquipment.location)
                                    )
                                  ])
                                ]),
                                _c("td", { staticClass: "centerItem p10" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      _vm._s(hardware.accessEquipment.model)
                                    )
                                  ])
                                ]),
                                _c("td", { staticClass: "centerItem p10" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      _vm._s(hardware.accessEquipment.serial)
                                    )
                                  ])
                                ]),
                                _c("td", { staticClass: "centerItem p20" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          hardware.accessEquipment.voltage.replace(
                                            ".",
                                            ","
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ]),
                                _c("td", { staticClass: "centerItem p25" }, [
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          hardware.accessEquipment.consumption.replace(
                                            ".",
                                            ","
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ])
                              ])
                            }
                          ),
                          _vm.PDTDetail.accessPermission
                            .accessPermissionEquipments < 1
                            ? _vm._l([1], function(equipo) {
                                return _c("tr", { key: equipo }, [
                                  _c("td", { staticClass: "centerItem p5" }, [
                                    _c("p", { staticClass: "mb-0" }, [
                                      _vm._v(_vm._s(equipo) + ".")
                                    ])
                                  ]),
                                  _c("td", { staticClass: "centerItem p10" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ]),
                                  _c("td", { staticClass: "centerItem p15" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ]),
                                  _c("td", { staticClass: "centerItem p15" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ]),
                                  _c("td", { staticClass: "centerItem p10" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ]),
                                  _c("td", { staticClass: "centerItem p10" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ]),
                                  _c("td", { staticClass: "centerItem p20" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ]),
                                  _c("td", { staticClass: "centerItem p25" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ])
                                ])
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _c("table", [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "centerItem p100 blueRow",
                                attrs: { colspan: "4" }
                              },
                              [
                                _c("h4", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    " Cambios en Servicios de Clientes administrados por Daycohost (especifique las tareas requeridas por parte de Dayco) "
                                  )
                                ])
                              ]
                            )
                          ]),
                          _vm._l(_vm.getServiceTasks, function(task, index) {
                            return _c("tr", { key: task.id }, [
                              _c("td", { staticClass: "centerItem p5" }, [
                                _vm._v(_vm._s(index + 1) + ".")
                              ]),
                              _c("td", { staticClass: "centerItem p95" }, [
                                _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(" " + _vm._s(task.name) + " ")
                                ])
                              ])
                            ])
                          }),
                          _vm.getServiceTasks.length < 1
                            ? _vm._l([1], function(task) {
                                return _c("tr", { key: task }, [
                                  _c("td", { staticClass: "centerItem p5" }, [
                                    _vm._v(_vm._s(task) + ".")
                                  ]),
                                  _c("td", { staticClass: "centerItem p95" }, [
                                    _c("p", { staticClass: "mb-0" })
                                  ])
                                ])
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "p20" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [_vm._v("Nombre/Apellido Usuario")])
                            ]),
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [_vm._v("Responsable de Cambio:")])
                            ])
                          ]),
                          _c("td", { staticClass: "p30" }, [
                            _c("p", { staticClass: "mb-0 ml-5" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getFullName(
                                      _vm.getSpecificContact(
                                        1,
                                        _vm.PDTDetail.accessPermission
                                          .accessContacts
                                      )
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("td", { staticClass: "p20" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [
                                _vm._v(
                                  "N° Teléf. y Dirección correo de Usuario"
                                )
                              ])
                            ]),
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _c("b", [_vm._v("Responsable:")])
                            ])
                          ]),
                          _c("td", { staticClass: "p30" }, [
                            _c("p", { staticClass: "mb-0 ml-5" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getPhone(
                                      _vm.getSpecificContact(
                                        1,
                                        _vm.PDTDetail.accessPermission
                                          .accessContacts
                                      )
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.getPhone(
                                      _vm.getSpecificContact(
                                        1,
                                        _vm.PDTDetail.accessPermission
                                          .accessContacts
                                      )
                                    ) != "" &&
                                      _vm.getEmail(
                                        _vm.getSpecificContact(
                                          1,
                                          _vm.PDTDetail.accessPermission
                                            .accessContacts
                                        )
                                      ) != ""
                                      ? " / "
                                      : ""
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.getEmail(
                                      _vm.getSpecificContact(
                                        1,
                                        _vm.PDTDetail.accessPermission
                                          .accessContacts
                                      )
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "centerItem p100",
                              attrs: { colspan: "4" }
                            },
                            [
                              _c("p", { staticClass: "mb-0" }, [
                                _c("b", [_vm._v("Fin del Formato CAM-001")])
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticClass: "p20 pb-2 pt-2" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-center align-center"
                              },
                              [
                                _c("span", { staticClass: "ml-1 mr-2" }, [
                                  _vm._v(" Uso público controlado ")
                                ]),
                                _c("img", {
                                  staticClass: "logoUso",
                                  attrs: {
                                    src: require("../../assets/triangulo.png"),
                                    alt: "Uso público controlado"
                                  }
                                })
                              ]
                            )
                          ]),
                          _c("td", { staticClass: "p100" }, [
                            _c("p", { staticClass: "mb-0 ml-1" }, [
                              _vm._v(
                                " Este documento es de distribución restringida y puede ser usado sólo por quienes lo reciben para la realización de sus actividades oficiales. Su contenido no puede ser publicado sin la autorización explícita de Dayco Telecom, C.A. "
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }